import React from 'react';

import Avatar from '@atlaskit/avatar/avatar';

const AvatarStatusDeclinedExample = (): React.JSX.Element => {
	return <Avatar name="John Smith" status="declined" />;
};

export default AvatarStatusDeclinedExample;
